export const UPDATE_MODEL_ACCURACY_STATE = "UPDATE_MODEL_ACCURACY_STATE"
export const MA_MORE_INTENT_LOADED = "MA_MORE_INTENT_LOADED"
export const MA_UPDATE_INTENT = "MA_UPDATE_INTENT"